import { useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import type { ProcessServerConfigFunction } from 'filepond';
import { MediaUploaderPanel, FILE_FORMATS, DialogTitle } from '@onesource/components';

type TMediaUploadDialogProps = {
  open: boolean;
  onClose: () => void;
  processHandler: ProcessServerConfigFunction;
  onUploaded: (key: string) => void;
};

export function MediaUploadDialog({ open, onClose, processHandler, onUploaded }: TMediaUploadDialogProps) {
  const handleUploaded = useCallback(
    (key: string) => {
      onUploaded(key);
      onClose();
    },
    [onUploaded, onClose],
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>Upload File</DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <MediaUploaderPanel
          allowedFormats={FILE_FORMATS.IMAGE}
          processHandler={processHandler}
          onUploaded={handleUploaded}
        />
      </DialogContent>
    </Dialog>
  );
}
